import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { $loader } from 'ziphy-web-shared/basic/utils';
import styles from './ButtonDefault.module.scss';
const ButtonDefault = ({ $element }) => {
    var _a;
    useEffect(() => {
        if ($element.show && $element.listenEventName) {
            const ids = $loader.subscribe($element.listenEventName, () => $element.runAction());
            return () => $loader.unsubscribe($element.listenEventName, ids);
        }
    }, [$element.show]);
    if (!$element.show) {
        return null;
    }
    return (_jsx(Button, Object.assign({ className: classNames(styles.button, (_a = $element.renderParams) === null || _a === void 0 ? void 0 : _a.className), mode: $element.config.mode, onClick: () => $element.runAction() }, { children: $element.config.text })));
};
export default observer(ButtonDefault);
